<template>
    <div class="box" id="box">
        <el-button type="primary">上传图片</el-button>
        <el-button type="primary" @click="show=true">选择图片</el-button>
        <div class="table" v-if="show">
            <div class="btnselect">
                <div>
                    <el-button type="primary" :disabled="selection.length==0" v-if="select">选择</el-button>
                </div>
                <el-button type="danger" icon="el-icon-close" @click="show=false"></el-button>
			</div>
            <mnTable ref="table" :data="data" row-key="id" height="500" @selection-change="selectionChange" stripe>
                <el-table-column type="selection" width="50"></el-table-column>
                <el-table-column width="150" label="ID" prop="id"></el-table-column>
                <el-table-column width="150" label="图片" prop="id">
                    <template #default="scope">
                        <img :src="scope.row.img" style="width: 40px;heigth:40px;" alt="">
                    </template>
                </el-table-column>
                <el-table-column width="150" label="文件原名" prop="filename"></el-table-column>
                <el-table-column width="150" label="mime类型" prop="mime"></el-table-column>
                <el-table-column width="150" label="创建时间" prop="createtime"></el-table-column>
                <el-table-column v-if="!select" fixed="right" label="操作" width="200" prop="Operations">
					<template #default>
						<el-button type="primary" size="small">选择</el-button>
      				</template>
   		 		</el-table-column>
            </mnTable>
        </div>
    </div>
  
</template>

<script>
	export default {
		emits: ['success', 'closed'],
        props: {
			select: { type: Boolean, default: false },
		},
		data() {
			return {
                selection:[],
                show:false,
                data:[{
                    id:1,
                    img:'https://oss.mingniukeji.net/upload/20221108/63c704fc82f495198f820fc83e636a04.jpg',
                    filename:'asdasdasd',
                    mime:'image/jpeg',
                    createtime:'179854643121'
                },{
                    id:1,
                    img:'asdasdasd',
                    filename:'asdasdasd',
                    mime:'image/jpeg',
                    createtime:'179854643121'
                },{
                    id:1,
                    img:'asdasdasd',
                    filename:'asdasdasd',
                    mime:'image/jpeg',
                    createtime:'179854643121'
                },{
                    id:1,
                    img:'asdasdasd',
                    filename:'asdasdasd',
                    mime:'image/jpeg',
                    createtime:'179854643121'
                },{
                    id:1,
                    img:'asdasdasd',
                    filename:'asdasdasd',
                    mime:'image/jpeg',
                    createtime:'179854643121'
                },{
                    id:1,
                    img:'asdasdasd',
                    filename:'asdasdasd',
                    mime:'image/jpeg',
                    createtime:'179854643121'
                },{
                    id:1,
                    img:'asdasdasd',
                    filename:'asdasdasd',
                    mime:'image/jpeg',
                    createtime:'179854643121'
                },{
                    id:1,
                    img:'asdasdasd',
                    filename:'asdasdasd',
                    mime:'image/jpeg',
                    createtime:'179854643121'
                },{
                    id:1,
                    img:'asdasdasd',
                    filename:'asdasdasd',
                    mime:'image/jpeg',
                    createtime:'179854643121'
                },{
                    id:1,
                    img:'asdasdasd',
                    filename:'asdasdasd',
                    mime:'image/jpeg',
                    createtime:'179854643121'
                },{
                    id:1,
                    img:'asdasdasd',
                    filename:'asdasdasd',
                    mime:'image/jpeg',
                    createtime:'179854643121'
                },{
                    id:1,
                    img:'asdasdasd',
                    filename:'asdasdasd',
                    mime:'image/jpeg',
                    createtime:'179854643121'
                },{
                    id:1,
                    img:'asdasdasd',
                    filename:'asdasdasd',
                    mime:'image/jpeg',
                    createtime:'179854643121'
                },{
                    id:1,
                    img:'asdasdasd',
                    filename:'asdasdasd',
                    mime:'image/jpeg',
                    createtime:'179854643121'
                },{
                    id:1,
                    img:'asdasdasd',
                    filename:'asdasdasd',
                    mime:'image/jpeg',
                    createtime:'179854643121'
                },{
                    id:1,
                    img:'asdasdasd',
                    filename:'asdasdasd',
                    mime:'image/jpeg',
                    createtime:'179854643121'
                },]
			}
		},
		mounted() {

		},
		methods: {
            selectionChange(selection){
				this.selection = selection;
			},
            close(){
                console.log(999999)
                this.show = false;
            }
		}
	}
</script>

<style scoped>
.btnselect{
    padding: 10px;
    display: flex;
    justify-content: space-between;
}
.tabletop{
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 10px;
    border-bottom: 1rpx solid red;
   
}
    .box{
        margin-top: 10px;
        position: relative;
    }
    .table{
        position: absolute;
        top: 40px;
        box-shadow: 0 0 5px 1px #8c939d;
        z-index: 9999;
        background-color: #fff;
    }
</style>
